export default {
  pages: {
    key: "title",
    data: [
      {title: 'Dashboard',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Users', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
